/* Maison theme — cart drawer, sticky ATC, tabs, menu, product variants */
(function () {
  'use strict';
  var money = window.Shopify && Shopify.currency ? Shopify.currency.active : '';

  function formatMoney(cents) {
    var fmt = window.themeMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------- Overlays ---------- */
  function openOverlay(el) { if (el) { el.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeOverlay(el) { if (el) { el.classList.remove('is-open'); document.body.style.overflow = ''; } }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open]');
    if (openBtn) { e.preventDefault(); var ov = document.getElementById(openBtn.getAttribute('data-open')); openOverlay(ov); var si = ov && ov.querySelector('[data-search-input]'); if (si) setTimeout(function () { si.focus(); }, 300); }
    var closeBtn = e.target.closest('[data-close]');
    if (closeBtn) { e.preventDefault(); closeOverlay(closeBtn.closest('.overlay')); }
    if (e.target.classList && e.target.classList.contains('overlay')) closeOverlay(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.overlay.is-open').forEach(closeOverlay);
  });

  /* ---------- Size chart modal ---------- */
  function openSizeChart(ov) {
    if (!ov) return;
    ov.hidden = false;
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeSizeChart(ov) {
    if (!ov) return;
    ov.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { ov.hidden = true; }, 260);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sizechart-open]')) {
      e.preventDefault();
      openSizeChart(document.querySelector('[data-sizechart-overlay]'));
    }
    if (e.target.closest('[data-sizechart-close]')) { e.preventDefault(); closeSizeChart(e.target.closest('[data-sizechart-overlay]')); }
    if (e.target.hasAttribute && e.target.hasAttribute('data-sizechart-overlay')) closeSizeChart(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var ov = document.querySelector('[data-sizechart-overlay].is-open'); if (ov) closeSizeChart(ov); }
  });

  /* ---------- Cart ---------- */
  function renderCart(cart) {
    var count = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = count; });
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var itemsWrap = drawer.querySelector('[data-cart-items]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var badgeEl = drawer.querySelector('[data-bundle-badge]');
    var origEl = drawer.querySelector('[data-cart-total-original]');
    var bundle = window.cartBundle || {};
    var base = 0;
    for (var bi = 0; bi < cart.items.length; bi++) { base += cart.items[bi].original_line_price; }
    var pct = 0;
    if (bundle.enable && count >= 2) { pct = count >= 4 ? bundle.t4 : (count === 3 ? bundle.t3 : bundle.t2); }
    if (pct > 0) {
      var discounted = Math.round(base * (100 - pct) / 100);
      if (totalEl) totalEl.textContent = formatMoney(discounted);
      if (origEl) { origEl.textContent = formatMoney(base); origEl.style.display = ''; }
      if (badgeEl) { badgeEl.textContent = 'EXTRA ' + pct + '%'; badgeEl.style.display = ''; }
    } else {
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      if (origEl) origEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }
    if (!itemsWrap) return;
    if (count === 0) {
      itemsWrap.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    itemsWrap.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?.*)?$/, '_160x$1') + '" alt="">' : '';
      var unit = it.original_price;
      var cmp = it.compare_at_price || 0;
      var priceHtml = (cmp && cmp > unit)
        ? '<span style="color:var(--muted);text-decoration:line-through;margin-right:6px;">' + formatMoney(cmp) + '</span><span style="color:var(--sale);">' + formatMoney(unit) + '</span>'
        : formatMoney(unit);
      return '<div class="cd__item">' +
        '<div class="media">' + img + '</div>' +
        '<div style="flex:1;min-width:0;">' +
          '<div style="font-size:15px;line-height:1.3;">' + it.product_title + '</div>' +
          '<div style="font-size:13px;color:var(--muted);margin:4px 0;">' + (it.variant_title || '') + '</div>' +
          '<div style="font-size:13px;margin-bottom:10px;">' + it.quantity + ' &times; ' + priceHtml + '</div>' +
          '<div style="display:flex;justify-content:space-between;align-items:center;">' +
            '<div class="qty" style="border:1px solid var(--border);">' +
              '<button type="button" data-cart-change="' + it.key + '" data-qty="' + (it.quantity - 1) + '" style="width:30px;height:30px;">&minus;</button>' +
              '<span style="width:26px;text-align:center;font-size:13px;">' + it.quantity + '</span>' +
              '<button type="button" data-cart-change="' + it.key + '" data-qty="' + (it.quantity + 1) + '" style="width:30px;height:30px;">+</button>' +
            '</div>' +
            '<a href="#" data-cart-change="' + it.key + '" data-qty="0" style="font-size:13px;text-decoration:underline;color:var(--muted);">Remove</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () {
      return fetchCart().then(function (cart) { renderCart(cart); openOverlay(document.getElementById('CartDrawer')); return cart; });
    });
  }

  function changeCart(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var change = e.target.closest('[data-cart-change]');
    if (change) { e.preventDefault(); changeCart(change.getAttribute('data-cart-change'), parseInt(change.getAttribute('data-qty'), 10)); }
  });

  // Add-to-cart forms (product form + quick add)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (form.closest('#QuickAdd')) closeOverlay(document.getElementById('QuickAdd'));
    addToCart([{ id: id, quantity: qty }]);
  });

  // Quick add buttons (single variant)
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    addToCart([{ id: qa.getAttribute('data-quick-add'), quantity: 1 }]);
  });

  window.MaisonAddToCart = function (id, qty) { return addToCart([{ id: id, quantity: qty || 1 }]); };

  /* ---------- Tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var root = tab.closest('[data-tabs]');
    var name = tab.getAttribute('data-tab');
    root.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.toggle('is-active', b === tab); });
    root.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === name);
    });
  });

  /* ---------- Product variant selection ---------- */
  function initProductForm(form) {
    var data = form.querySelector('[data-variants-json]');
    if (!data || form.dataset.variantsInit) return;
    form.dataset.variantsInit = '1';
    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[name="id"]');
    var scope = form.closest('.qa') || document;
    var priceEl = scope.querySelector('[data-current-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function currentOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (sel) {
        opts[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
      });
      return opts;
    }
    function syncLabels() {
      form.querySelectorAll('select[data-option-index]').forEach(function (sel) {
        var row = sel.parentNode;
        var lbl = row && row.querySelector('.vr-value');
        if (lbl) lbl.textContent = sel.value;
      });
    }
    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return !opts[i] || o === opts[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
      }
      syncLabels();
    }
    form.querySelectorAll('[data-option-index]').forEach(function (sel) { sel.addEventListener('change', update); });

    // sticky bar option selects sync back to the main form
    document.querySelectorAll('[data-sticky-option-index]').forEach(function (ssel) {
      ssel.addEventListener('change', function () {
        var idx = ssel.getAttribute('data-sticky-option-index');
        var val = ssel.value;
        var group = form.querySelector('[data-option-index="' + idx + '"]');
        if (!group) return;
        if (group.tagName === 'SELECT') {
          group.value = val; group.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // color: hidden input + swatch buttons
          var swGroup = group.closest('[data-swatch-group]');
          var btn = swGroup && swGroup.querySelector('[data-swatch][data-value="' + val.replace(/"/g, '\\"') + '"]');
          if (btn) { btn.click(); } else { group.value = val; update(); }
        }
      });
    });
    form.querySelectorAll('[data-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-swatch-group]');
        group.querySelectorAll('[data-swatch]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var hidden = group.querySelector('[data-option-index]');
        if (hidden) { hidden.value = btn.getAttribute('data-value'); update(); }
        var lbl = group.querySelector('[data-swatch-label]');
        if (lbl) lbl.textContent = btn.getAttribute('data-value');
      });
    });
  }
  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  /* ---------- Quick add drawer ---------- */
  var qaDrawer = document.getElementById('QuickAdd');
  var qaLoadingHTML = qaDrawer ? qaDrawer.querySelector('[data-quick-add-body]').innerHTML : '';
  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (!qv || !qaDrawer) return;
    e.preventDefault();
    var body = qaDrawer.querySelector('[data-quick-add-body]');
    body.innerHTML = qaLoadingHTML;
    openOverlay(qaDrawer);
    var url = qv.getAttribute('data-quick-view').split('?')[0] + '?section_id=product-quick-add';
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        body.innerHTML = html;
        var form = body.querySelector('[data-product-form]');
        if (form) initProductForm(form);
      })
      .catch(function () {
        body.innerHTML = '<div class="qa-drawer__error">Something went wrong. Please try again.</div>';
      });
  });

  // qty steppers on product page
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input[name="quantity"]');
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, val);
  });

  /* ---------- Sticky ATC ---------- */
  var sticky = document.querySelector('.sticky-atc');
  if (sticky) {
    var anchor = document.querySelector('[data-atc-anchor]');
    window.addEventListener('scroll', function () {
      var show = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 560;
      sticky.classList.toggle('is-visible', show && !document.querySelector('.overlay.is-open'));
    }, { passive: true });
  }

  /* ---------- Read-more description ---------- */
  document.querySelectorAll('[data-desc-toggle]').forEach(function (btn) {
    var wrap = btn.closest('[data-desc]');
    var body = wrap.querySelector('[data-desc-body]');
    // hide toggle if content isn't clamped
    if (body.scrollHeight <= body.clientHeight + 4) { btn.style.display = 'none'; }
    btn.addEventListener('click', function () {
      wrap.classList.toggle('is-open');
      btn.textContent = wrap.classList.contains('is-open') ? 'Read less' : 'Read more';
    });
  });

  /* ---------- Product gallery carousel dots ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var dotsWrap = gallery.parentNode.querySelector('[data-gallery-dots]');
    if (!dotsWrap) return;
    var slides = gallery.querySelectorAll('.g');
    if (slides.length < 2) return;
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      if (i === 0) b.classList.add('is-active');
      b.addEventListener('click', function () { gallery.scrollTo({ left: gallery.clientWidth * i, behavior: 'smooth' }); });
      dotsWrap.appendChild(b);
    });
    gallery.addEventListener('scroll', function () {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dotsWrap.querySelectorAll('button').forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
    }, { passive: true });
  });

  /* ---------- Address province selectors ---------- */
  document.querySelectorAll('[id^="AddressCountry_"]').forEach(function (countrySel) {
    var suffix = countrySel.id.replace('AddressCountry_', '');
    var provinceContainer = document.getElementById('AddressProvinceContainer_' + suffix);
    var provinceSel = document.getElementById('AddressProvince_' + suffix);
    if (!provinceContainer || !provinceSel) return;
    function updateProvinces() {
      var opt = countrySel.options[countrySel.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
      provinceSel.innerHTML = '';
      if (provinces.length === 0) { provinceContainer.style.display = 'none'; return; }
      provinces.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        provinceSel.appendChild(o);
      });
      if (provinceSel.getAttribute('data-default')) provinceSel.value = provinceSel.getAttribute('data-default');
      provinceContainer.style.display = 'block';
    }
    if (countrySel.getAttribute('data-default')) countrySel.value = countrySel.getAttribute('data-default');
    countrySel.addEventListener('change', updateProvinces);
    updateProvinces();
  });

  /* ---------- Predictive search ---------- */
  document.querySelectorAll('[data-predictive-search]').forEach(function (form) {
    var input = form.querySelector('[data-search-input]');
    var results = form.parentNode.querySelector('[data-search-results]');
    if (!input || !results) return;
    var timer, controller;
    function money(v) {
      // suggest.json prices are decimal strings; cart prices are cents
      if (typeof v === 'string') { return formatMoney(Math.round(parseFloat(v) * 100)); }
      return formatMoney(v);
    }
    function render(products, terms) {
      if (!products.length) {
        results.innerHTML = '<div class="search-results__empty">No matches for &ldquo;' + terms + '&rdquo;</div>';
        results.hidden = false; return;
      }
      var items = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/, '_120x$1') : (p.image || '');
        return '<a class="search-results__item" href="' + p.url + '">' +
          '<span class="search-results__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="search-results__meta"><span class="search-results__title">' + p.title + '</span>' +
          '<span class="search-results__price">' + money(p.price) + '</span></span></a>';
      }).join('');
      results.innerHTML = items +
        '<a class="search-results__all" href="' + window.routes_search + '?q=' + encodeURIComponent(terms) + '">View all results for &ldquo;' + terms + '&rdquo;</a>';
      results.hidden = false;
    }
    input.addEventListener('input', function () {
      var terms = input.value.trim();
      clearTimeout(timer);
      if (terms.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = '/search/suggest.json?q=' + encodeURIComponent(terms) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, terms);
          }).catch(function () {});
      }, 200);
    });
    input.addEventListener('blur', function () { setTimeout(function () { results.hidden = true; }, 180); });
  });

  /* ---------- Init ---------- */
  document.addEventListener('click', function (e) {
    var vote = e.target.closest('.rv-vote');
    if (!vote || vote.dataset.voted) return;
    vote.dataset.voted = '1';
    var m = vote.textContent.match(/(\d+)\s*$/);
    var n = m ? parseInt(m[1], 10) : 0;
    vote.textContent = vote.textContent.replace(/\d+\s*$/, (n + 1));
  });

  fetchCart().then(renderCart);
})();
